import type { CopyShape } from "../../intl";

import type { BRAND_LINKS_COPY_PT_BR } from "../links.copy";

export const BRAND_LINKS_COPY_EN_US: CopyShape<typeof BRAND_LINKS_COPY_PT_BR> = {
  site: "Discover Tãmi",
  signUp: "Create my account",
  instagram: "Instagram",
  youtube: "YouTube",
  guide: "The complete Tãmi guide",
};
